// Libraries
var React = require('react');

// Styles
require('./WatchFace.scss');

// Assets
// var iwcLogo = require('images/iwc_logo-dark.svg');
var watchFace = require('./watch/clock.png');
var hours = require('./watch/1_h.png');
var minutes = require('./watch/2_m.png');
var seconds = require('./watch/3_s.png');
var days = require('./watch/days.png');

class WatchFaceModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hours: 0,
			minutes: 0,
			seconds: 0,
			day: (new Date()).getDate() + 3,
		};
	}

	to360(x, base) {
		if (x === 0 || x === base) {
			return 0;
		}

		return x / base * 360;
	}

	componentDidMount() {
		setInterval(() => {
			const date = new Date();

			this.setState({
				hours: (date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds()) / 3600,
				minutes: (date.getMinutes() * 60 + date.getSeconds()) / 60,
				seconds: (date.getSeconds() * 1000 + date.getMilliseconds()) / 1000,
			});
		}, 250)

		setInterval(() => {
			const date = new Date();

			this.setState({
				day: date.getDate() + 3,
			});
		}, 8.64e+7)
	}

	render() {
		var hoursTransform = {
			transform: `translate(-50%, -50%) rotate(${this.to360(this.state.hours, 12)}deg)`,
		}
		var minutesTransform = {
			transform: `translate(-50%, -50%) rotate(${this.to360(this.state.minutes, 60)}deg)`,
		}
		var secondsTransform = {
			transform: `translate(-50%, -50%) rotate(${this.to360(this.state.seconds, 60)}deg)`,
		}
		var daysTransform = {
			transform: `translate(-50%, -50%) rotate(${this.to360(this.state.day, 31)}deg)`,
		}

		return (
			<span className="WatchFace">
				<div className="WatchFace__container">
					<img className="WatchFace__component" src={days} alt="" style={daysTransform} />
					<img className="WatchFace__base" src={watchFace} alt="" />
					<img className="WatchFace__component" src={hours} alt="" style={hoursTransform} />
					<img className="WatchFace__component" src={minutes} alt="" style={minutesTransform} />
					<img className="WatchFace__component" src={seconds} alt="" style={secondsTransform} />
				</div>
			</span>
		);
	}
}

module.exports = WatchFaceModule;



// WEBPACK FOOTER //
// ./src/common/WatchFace/WatchFaceModule.js